// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export const StyledHorizontalCarousel = Styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const HorizontalGrid = Styled.div`
  height: 100%;
  display: flex;
`;
